import { useContext } from "react";
import CustomDateRangePicker from "../../analytics/components/DateRangePicker";
import LoadingBookings from "../../common/LoadingBookings";
import SalesGraph from "../../graph/booking/SalesGraph";
import { AnalyticsContext } from "../../../store/analyticsS";
import { HotelContext } from "../../../store/hotel";
import Constant from "../../../constant/Constant";
import SingleHotelFeedbackCountViewer from "../component/SingleHotelFeedbackCountViewer";

const FeedbackCountScreen = () => {

  const analyticsContext = useContext(AnalyticsContext);
  const hotelContext = useContext(HotelContext);
  let bookingAnalytics = analyticsContext.feedbackCountAnalytics;
  let allHotels = Object.keys(bookingAnalytics);

  const dateContent = (
    <div style={{ position: "absolute", top: "15px", left: "30px", zIndex: 4 }}>
      <CustomDateRangePicker
        startDay={hotelContext.startDay}
        days={hotelContext.days}
        onDateChange={(date, days) => {
          hotelContext.onUpdateDate(date, days);
        }}
      />
    </div>
  );

  if (analyticsContext.isFeedbackCountAnalyticsLoading || !analyticsContext.isFeedbackCountAnalyticsLoaded) {
    return (
      <>
        {dateContent}
        <LoadingBookings />
      </>
    );
  }
  return (
    <>
      {dateContent}
      {allHotels.length > 0 && (
        <SalesGraph
          bookingAnalytics={bookingAnalytics}
          title="Feedback Count Analytics"
          allOptions={Constant.FeedbackCountAnalyticsShort}
          isTablularData={analyticsContext.isTabularData}
          onToggleTabularData={() => {
            analyticsContext.onToggleTabularData();
          }}
          isBar={analyticsContext.isBar}
          isHotel={analyticsContext.isHotel}
          isDate={analyticsContext.isDate}
          isPercentage={analyticsContext.isPercentage}
          onTogglePercentage={() => {
            analyticsContext.onTogglePercentage();
          }}
          onToggleBar={() => {
            analyticsContext.onToggleBar();
          }}
          onToggleHotel={() => {
            analyticsContext.onToggleHotel();
          }}
          onToggleDate={() => {
            analyticsContext.onToggleDate();
          }}
        />
      )}
      {!analyticsContext.isTabularData &&
        allHotels.map((hotel) => {
          return (
            <SingleHotelFeedbackCountViewer
              key={hotel}
              hotelName={hotel}
              allDateData={bookingAnalytics[hotel]}
            />
          );
        })}
    </>
  );
};

export default FeedbackCountScreen
